import { BRAND } from "constants/brand";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useUser from "hooks/useUser";

const ChangePassword = (props) => {
    const nodeRef = useRef();
    const { loading, changeUserPassword } = useUser();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect(() => {
        if (!props.show) {
            setPassword("");
            setConfirmPassword("");
        }
    }, [props.show]);

    const submitHandler = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            props.showMessage("error", "هناك خطأ", "كلمة المرور يجب أن تكون 6 أحرف على الأقل");
            return;
        }
        if (password !== confirmPassword) {
            props.showMessage("error", "هناك خطأ", "كلمتا المرور غير متطابقتين");
            return;
        }

        try {
            const response = await changeUserPassword(props.user.id, password, confirmPassword);

            if (response?.user?.id) {
                props.showMessage(
                    "success",
                    "تم التعديل",
                    "تم تغيير كلمة المرور وتسجيل خروج الحساب من كل الأجهزة",
                );
                props.close();
            } else {
                props.showMessage(
                    "error",
                    "هناك خطأ",
                    response?.response?.data?.message || "حدث خطأ غير متوقع",
                );
            }
        } catch (err) {
            props.showMessage(
                "error",
                "هناك خطأ",
                err?.response?.data?.message || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
            <CSSTransition
                mountOnEnter
                unmountOnExit
                nodeRef={nodeRef}
                in={props.show}
                timeout={400}
                classNames="show"
            >
                <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                    {loading ? (
                        <div className="loading-spinner center">
                            <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                        </div>
                    ) : null}
                    <div className="head center">
                        <h5>تغيير كلمة المرور {props.user?.name ? `- ${props.user.name}` : ""}</h5>
                        <FontAwesomeIcon icon={faClose} onClick={props.close} />
                    </div>
                    <Form className="form" onSubmit={submitHandler}>
                        <div className="form-warning">
                            بعد الحفظ يتم تسجيل خروج هذا الحساب من كل الأجهزة، ويتوقف وصول الإشعارات
                            إليها. يجب تسجيل الدخول من جديد بكلمة المرور الجديدة.
                        </div>
                        <Form.Group className="mb-3" controlId="password">
                            <Form.Label>
                                كلمة المرور الجديدة<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="كلمة المرور الجديدة"
                                autoComplete="new-password"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="confirm_password">
                            <Form.Label>
                                تأكيد كلمة المرور<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="تأكيد كلمة المرور"
                                autoComplete="new-password"
                                required
                            />
                        </Form.Group>
                        <div className="buttons">
                            <button className="cancel" onClick={props.close} type="button">
                                إلغاء
                            </button>
                            <button className="button" type="submit" disabled={loading}>
                                حفظ
                            </button>
                        </div>
                    </Form>
                </div>
            </CSSTransition>
        </div>
    );
};

export default ChangePassword;
